import { useCallback, useEffect, useState } from 'react';
import { Table, Spinner } from 'react-bootstrap';

import { useHttpUtils } from '../../Utilities/useHttpUtils';
import DateAsLocaleString from '../../Utilities/DateAsLocaleString';
import useAlert from '../../Alerts/useAlert';
import AdminTile from './AdminTile';

const GetHeartbeats = () => {
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const [heartbeats, setHeartbeats] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [variant, setVariant] = useState();

    const getHeartbeats = useCallback(() => {
        setLoading(true);
        fetchDataAuthenticated("api/v1/admin/heartbeat", "GET")
            .then(response => {
                if (response.status === 403) {
                    return Promise.reject({ title: "Unauthorised", detail: "Unable to fetch heartbeats due to being unauthorised. Admin privilege required" });
                }
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                return response.json();
            })
            .then(data => {
                setError("");
                setHeartbeats(data);
                if (data.length === 0) {
                    setVariant("warning");
                } else {
                    setVariant("");
                }
            })
            .catch(error => {
                setHeartbeats(null);
                setVariant("danger");
                setAlert("danger", error.title, error.detail);
                setError(error.detail);
            })
            .finally(() => setLoading(false));
    }, [fetchDataAuthenticated, setAlert]);

    useEffect(() => {
        getHeartbeats();
    }, [getHeartbeats]);

    function HeartbeatsTable() {
        if (loading) {
            return (<Spinner />);
        }
        if (error) {
            return (<div>{error}</div>);
        }

        if (heartbeats.length === 0) {
            return (<div>No Hearbeats</div>);
        }

        return (
            <Table className="w-100">
                <thead>
                    <tr>
                        <th>Business Unit</th>
                        <th>Message Last Received</th>
                    </tr>
                </thead>
                <tbody>
                    {heartbeats && heartbeats.map((heartbeat, index) =>
                        <tr key={`heartbeat-${index}`}>
                            <td>{heartbeat.businessUnit}</td>
                            <td><DateAsLocaleString date={heartbeat.messageSentAtLocalTime} /></td>
                        </tr>
                    )}
                </tbody>
            </Table>
        )
    }

    return (
        <AdminTile
            title={"Heartbeat Monitor"}
            description={"Check the latest heartbeat information from L3"}
            variant={variant}
            onRefresh={getHeartbeats}>
            <HeartbeatsTable/>
        </AdminTile>
    )
}

export default GetHeartbeats;